// @react
import React, { useEffect } from 'react'
import { ExternalRouteNames } from 'constants/routeNames'
// @components

/******************************************
 * TEMP ROUTE TO SHOW SOME UTILITY LINKS
 * FOR CLIENT UAT
 ******************************************/

const MyATD = () => {
  // @todo fix this hack
  useEffect(() => {
    if (process.env.REACT_APP_HOST_ENV === 'PROD') {
      window.location.assign(ExternalRouteNames.ATD_HOME)
    }
  }, [])

  /******************************************
   * RENDER
   ******************************************/
  return <></>
}
export default MyATD
